import React, { PureComponent } from "react";
import { UploadWithTitle } from "../../reusableComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUploadAttachmentApiResponse } from "../../reusableComponent/helper";
import {
  FILE_SIZE_LIMIT,
  FILE_SIZE_LIMIT_AGENDA,
  OTHER_FORMATS_AGENDA,
  OTHER_FORMATS
} from "../../../constant";
// actions
import {
  uploadFileAction,
  uploadFileTitleAction
} from "../../../actions/common.action";
// helpers
import { FormDataForImage } from "../../../helper";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class UploadAttchementsWithTitle extends PureComponent {
  MAX_UPLOADS = 1;

  state = {
    attachments: [],
    fileUploadPercentage: 0
  };

  onRemoveFiles = index => {
    // remove by index
    this.setState(prevState => {
      prevState.attachments.splice(index, 1);
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onClose = uploaded => {
    const { onCloseModal = () => {} } = this.props;
    if (
      this.state.fileUploadPercentage > 0 &&
      this.state.fileUploadPercentage <= 100 &&
      !uploaded
    ) {
      let exitUpload = window.confirm(
        "File upload in progress, are you sure you want to cancel?"
      );
      if (exitUpload) {
        typeof onCloseModal === "function" && onCloseModal(uploaded);
      }
    } else {
      typeof onCloseModal === "function" && onCloseModal(uploaded);
    }
  };

  calculateUploadingPercentage = e => {
    const { fileUploadPercentage } = this.state;
    var percentComplete = Math.ceil((e.loaded / e.total) * 100);
    this.setState({
      fileUploadPercentage: percentComplete
    });
  };

  getUploadAttachmentDetail = () => {
    const { attachments } = this.state;
    const attachmentPayload = FormDataForImage(attachments, "file");
    getUploadAttachmentApiResponse(
      attachmentPayload,
      this.calculateUploadingPercentage,
      this.uploadAttachmentApiCallback
    );
  };

  uploadAttachmentApiCallback = http => {
    var response = {};
    // checking readyState === 4 which means that the request
    // had been sent, the server had finished returning the response and
    // the browser had finished downloading the response content.
    if (http.readyState === 4 && http.status === 200) {
      response = http.response;
      this.setState({
        response: JSON.parse(response)
      });
    }
  };

  onSubmit = () => {
    try {
      const { uploadFileAction, onSubmit } = this.props;
      const { attachments } = this.state;
      const attachmentPayload = FormDataForImage(attachments, "file");
      if (!attachments.length || !attachments[0].title) {
        toast.error(
          <p className="toast-text-alignment">
            Document and title of file is mandatory
          </p>,
          errorToastStyle
        );
      } else {
        this.setState(
          {
            isLoading: true
          },
          async () => {
            this.getUploadAttachmentDetail();
            const response = await uploadFileAction(
              undefined,
              attachmentPayload
            );
            const { data, status, message } = response || {};
            // after uploading file
            // we need id from its response and send it with the title
            if (data && data.id && attachments[0].title) {
              const { status, message } = await uploadFileTitleAction(
                undefined,
                { fid: data.id, title: attachments[0].title }
              );
              if (!status) {
                toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                ); // message will show in case of error while uploading title
              } else {
                toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                );
              }
            } else {
              // after file
              status
                ? toast.success(
                    <p className="toast-text-alignment">{message}</p>,
                    successToastStyle
                  )
                : toast.error(
                    <p className="toast-text-alignment">{message}</p>,
                    errorToastStyle
                  );
            }

            if (status) {
              // onSubmit from props must retun a promise
              if (typeof onSubmit === "function") {
                await onSubmit(data.id);
              }
            }

            // set the loader off
            this.setState(
              {
                isLoading: false
              },
              () => {
                const params =
                  data && data.id
                    ? { ...data, title: attachments[0].title }
                    : {};
                this.onClose(params); // close the modal
                /// after uploading image need to send the ids of uploaded image to
                //  below api
              }
            );
          }
        );
      }
    } catch (error) {
      console.error(
        `Error while uplading image on agenda detail ${error.message}`
      );
    }
  };

  onTitleChange = e => {
    const { value } = e.target;
    this.setState(prevState => {
      prevState.attachments[0]["title"] = value;
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onEditToggle = index => {
    // remove by index
    this.setState(prevState => {
      prevState.attachments[index]["toggleEdit"] = !prevState.attachments[
        index
      ]["toggleEdit"];
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onAttachment = e => {
    try {
      const { files } = e.target;
      const { fileFormats } = this.props;
      // max 1 file can be uploaded at a time
      if (files.length > this.MAX_UPLOADS) {
        toast.error(
          <p className="toast-text-alignment">
            Max one file can uploaded at a time.
          </p>,
          errorToastStyle
        );
        return false;
      }

      const extension = files[0].name
        .substr(files[0].name.lastIndexOf(".") + 1, files[0].name.length)
        .toLowerCase();

      // if file type is invalid
      const validFormat = fileFormats.find(value => {
        return files[0].name.toLowerCase().endsWith(value);
      });
      if (!validFormat) {
        toast.error(
          <p className="toast-text-alignment">File type not supported</p>,
          errorToastStyle
        );
        return false;
      }

      if (
        files[0].size > FILE_SIZE_LIMIT.OTHER_FORMATS &&
        OTHER_FORMATS.includes(extension)
      ) {
        toast.error(
          <p className="toast-text-alignment">
            The file exceeds the maximum size limit of 10 MB
          </p>,
          errorToastStyle
        );
        return false;
      }

      //
      this.setState(() => {
        // files
        const attachments = [];
        // attachments
        for (let i = 0; i < files.length; i++) {
          files[i].toggleEdit = true;
          files[i].title = "";
          attachments.push(files[i]);
        }

        return {
          attachments
        };
      });
    } catch (e) {
      console.error(`Error while file section ${e.message}`);
    }
  };

  render() {
    const {
      props: { displayModal, fileFormats },
      state: { isLoading, attachments, fileUploadPercentage },
      onClose,
      onSubmit,
      onEditToggle,
      onTitleChange,
      onRemoveFiles,
      onAttachment
    } = this;

    return displayModal ? (
      <UploadWithTitle
        onClose={onClose} // on close of modal function
        title={
          <>
            <h6>Only {fileFormats.join(" ")} file format is supported</h6>
          </>
        }
        titleField={true}
        onEditToggle={onEditToggle}
        isLoading={isLoading}
        onRemoveFile={onRemoveFiles}
        onUpload={onSubmit}
        onTitleUpdate={onTitleChange}
        onAttachFile={onAttachment}
        attachments={attachments}
        containerClass="agenda-detail-attachments"
        fileFormats={fileFormats}
        loadingPercent={fileUploadPercentage}
      />
    ) : null;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadFileAction
    },
    dispatch
  );
}

const UploadAttachmentsWithTitleComponent = connect(
  null,
  mapDispatchToProps
)(UploadAttchementsWithTitle);
export { UploadAttachmentsWithTitleComponent };
